import React from 'react'

interface TitleProps {
    name: string
    color?: string  // add optional color prop
}

const TitleTemp: React.FC<TitleProps> = ({ name, color = 'text-defaultBlue' }) => {
    return (
        <h2 className={`text-3xl md:text-c font-semibold text-center mb-8 mt-8 px-5 ${color}`}>
            {name}
        </h2>
    )
}

export default TitleTemp